import { render } from "./DashboardHospital.vue?vue&type=template&id=0e4f0122&scoped=true"
import script from "./DashboardHospital.vue?vue&type=script&lang=js"
export * from "./DashboardHospital.vue?vue&type=script&lang=js"

import "./DashboardHospital.vue?vue&type=style&index=0&id=0e4f0122&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0e4f0122"]])

export default __exports__